import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/prathamesh/Downloads/claude-transfer/locobuzz-website/app/industries/energy-utilities/EnergyBody.jsx");
